export default __webpack_public_path__ + "static/media/higher_primary_hi_ident_no_margin.947bb246.svg";